import { value } from '@takeshape/util';
import { updateAuthentication } from "../util/authentication.js";
import { isCompleteGraphQLConfig } from "../util/config.js";
import { getHealthCheck } from "../util/health.js";
const serviceProvider = {
    name: 'fauna',
    title: 'Fauna',
    description: 'Fauna is a flexible, developer-friendly, transactional database delivered as a secure and scalable cloud API with native GraphQL. Never again worry about database provisioning, scaling, sharding, replication, or correctness.',
    categories: ['database'],
    links: [{ title: 'Homepage', url: 'https://fauna.com/' }],
    serviceType: 'graphql',
    introspectionType: 'graphql',
    createId: value('fauna'),
    getFormSchema: value({
        type: 'object',
        properties: {
            id: {
                title: 'Slug',
                type: 'string',
                pattern: '[0-9A-Za-z_-]+',
                default: 'fauna'
            },
            title: {
                title: 'Name',
                type: 'string',
                default: 'Fauna'
            },
            namespace: {
                title: 'Namespace',
                type: 'string',
                pattern: '^[A-Z][A-Za-z]+$',
                default: 'Fauna'
            },
            endpoint: {
                title: 'Endpoint',
                type: 'string',
                pattern: '^https:\\/\\/graphql(.eu|.us)?.fauna(-preview)?.com\\/graphql$'
            },
            authentication: {
                title: 'Authentication',
                type: 'object',
                properties: {
                    token: {
                        title: 'Secret Key',
                        type: 'string',
                        '@sensitive': true
                    }
                },
                required: ['token']
            }
        },
        required: ['title', 'id', 'namespace', 'endpoint', 'authentication']
    }),
    getFormConfig: value({
        order: ['title', 'id', 'namespace', 'endpoint', 'authentication'],
        properties: {
            title: {
                widget: 'singleLineText',
                instructions: 'Human-readable identifier for use in the UI.'
            },
            namespace: {
                widget: 'singleLineText',
                instructions: 'A pascal-case prefix that will be added to types in your Fauna API.'
            },
            id: {
                widget: 'singleLineText',
                instructions: 'Unique identifier for use in the API and Schema.'
            },
            endpoint: {
                widget: 'singleLineText',
                instructions: 'API endpoint URL e.g. "https://graphql.[region-group].fauna.com/graphql"'
            },
            authentication: {
                properties: {
                    token: {
                        widget: 'sensitiveField',
                        instructions: 'Secret key from your Fauna account'
                    }
                },
                order: ['token']
            }
        }
    }),
    getConfig(formData) {
        const config = {
            title: formData.title ?? 'Fauna',
            namespace: formData.namespace ?? 'Fauna',
            provider: 'fauna',
            serviceType: 'graphql',
            authenticationType: 'bearer',
            options: {
                endpoint: formData.endpoint
            }
        };
        return updateAuthentication(config, formData, { type: 'bearer' });
    },
    isCompleteConfig: isCompleteGraphQLConfig,
    getHealthCheck: getHealthCheck({ checkName: 'graphqlIntrospection' })
};
export default serviceProvider;
